import api from '../../utils/api';

export const removeFloor = (id: number) =>
  api.delete({
    url: `/floor/${id}`,
  });
